var _defs, _path, _path2, _path3, _path4, _path5, _circle, _ellipse, _path6, _path7, _ellipse2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle2, _ellipse3, _path16, _path17, _ellipse4, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoScenarioImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_184",
    "data-name": "Group 184",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 335.34,
    height: 237.559,
    viewBox: "0 0 335.34 237.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01bea1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#941efd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.86,
    y1: 0.813,
    x2: 0.275,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M535.005,557.76H235.12a17.225,17.225,0,0,1-17.206-17.206V380.49a17.225,17.225,0,0,1,17.206-17.206H535.005a17.225,17.225,0,0,1,17.206,17.206V540.555A17.225,17.225,0,0,1,535.005,557.76Z",
    transform: "translate(-217.914 -320.202)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M491.381,661.944H297.724c-.242,0-.485-.005-.724-.019l91.591-51.582c1.744-1,5.657-1.355,8.739-.788a7.919,7.919,0,0,1,2.424.788l61.469,34.616,2.945,1.656Z",
    transform: "translate(-255.766 -437.941)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M633.241,675.9h-167.5L498.2,660.571l2.336-1.1,42.3-19.976c2.773-1.309,9.444-1.391,12.7-.247q.328.117.609.247Z",
    transform: "translate(-336.529 -451.897)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M236.077,365.284a16.181,16.181,0,0,0-16.163,16.163V541.512a16.181,16.181,0,0,0,16.163,16.163H535.962a16.181,16.181,0,0,0,16.163-16.163V381.447a16.181,16.181,0,0,0-16.163-16.163Z",
    transform: "translate(-218.871 -321.159)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M546.492,556.734H246.606a4.7,4.7,0,0,1-4.692-4.693V391.976a4.7,4.7,0,0,1,4.692-4.692H546.492a4.7,4.7,0,0,1,4.693,4.692V552.041a4.7,4.7,0,0,1-4.692,4.693ZM246.606,388.327a3.654,3.654,0,0,0-3.65,3.65V552.041a3.654,3.654,0,0,0,3.65,3.65H546.492a3.654,3.654,0,0,0,3.65-3.65V391.976a3.654,3.654,0,0,0-3.65-3.65Z",
    transform: "translate(-229.401 -331.688)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 32.275,
    cy: 32.275,
    r: 32.275,
    transform: "translate(217.998 20.344)",
    fill: "#ff6584"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 40.878,
    cy: 51.167,
    rx: 40.878,
    ry: 51.167,
    transform: "translate(222.888 67.793)",
    fill: "#f2f2f2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M504.153,325.365h.112l2.021,115.9h-4.268Z",
    transform: "translate(-240.275 -216.694)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M730.763,635.745h0a1.011,1.011,0,0,1-.424,1.365l-5.863,3.087-.942-1.789,5.863-3.087A1.011,1.011,0,0,1,730.763,635.745Z",
    transform: "translate(-459.912 -450.347)",
    fill: "#ccc"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 40.878,
    cy: 51.167,
    rx: 40.878,
    ry: 51.167,
    transform: "translate(105.365 67.793)",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M503.632,567.724h0a1.011,1.011,0,0,0-1.365-.423l-4.093,2.155-1.4-80.374h-.112l-2.134,115.9h4.268l-.58-33.258,5-2.63a1.011,1.011,0,0,0,.423-1.365Z",
    transform: "translate(-350.305 -380.41)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M563.342,282.653c28.607,0,51.858,53.9,51.858,89.709S592.01,437.2,563.4,437.2s-51.8-29.027-51.8-64.834S534.735,282.653,563.342,282.653Z",
    transform: "translate(-358.48 -281.61)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M617.577,528.356a1.28,1.28,0,0,0-1.73-.537l-5.186,2.73-1.776-101.843h-.142l-2.7,146.853h5.407l-.735-42.142,6.329-3.332a1.28,1.28,0,0,0,.536-1.73Z",
    transform: "translate(-403.677 -351.514)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M537.005,555.76H237.12a17.225,17.225,0,0,1-17.206-17.206V378.49a17.225,17.225,0,0,1,17.206-17.206H537.005a17.225,17.225,0,0,1,17.206,17.206V538.555A17.225,17.225,0,0,1,537.005,555.76Z",
    transform: "translate(-218.871 -319.244)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M493.381,659.944H299.724c-.242,0-.485-.005-.724-.019l91.591-51.582c1.744-1,5.657-1.355,8.739-.788a7.918,7.918,0,0,1,2.424.788l61.469,34.616,2.945,1.656Z",
    transform: "translate(-256.723 -436.984)",
    fill: "url(#linear-gradient)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M635.241,673.9h-167.5L500.2,658.571l2.336-1.1,42.3-19.976c2.773-1.309,9.444-1.391,12.7-.247q.328.117.609.247Z",
    transform: "translate(-337.486 -450.94)",
    fill: "url(#linear-gradient-2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M537.005,555.76H237.12a17.225,17.225,0,0,1-17.206-17.206V378.49a17.225,17.225,0,0,1,17.206-17.206H537.005a17.225,17.225,0,0,1,17.206,17.206V538.555A17.225,17.225,0,0,1,537.005,555.76ZM237.119,362.327a16.181,16.181,0,0,0-16.163,16.163V538.555a16.181,16.181,0,0,0,16.163,16.163H537.005a16.181,16.181,0,0,0,16.163-16.163V378.49a16.181,16.181,0,0,0-16.163-16.163Z",
    transform: "translate(-218.871 -319.244)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M548.492,554.734H248.606a4.7,4.7,0,0,1-4.692-4.693V389.976a4.7,4.7,0,0,1,4.692-4.692H548.492a4.7,4.7,0,0,1,4.692,4.692V550.041A4.7,4.7,0,0,1,548.492,554.734ZM248.606,386.327a3.654,3.654,0,0,0-3.65,3.65V550.041a3.654,3.654,0,0,0,3.65,3.65H548.492a3.654,3.654,0,0,0,3.65-3.65V389.976a3.654,3.654,0,0,0-3.65-3.65Z",
    transform: "translate(-230.358 -330.731)",
    fill: "#ccc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 32.275,
    cy: 32.275,
    r: 32.275,
    transform: "translate(219.04 19.301)",
    fill: "#ff6584"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 40.878,
    cy: 51.167,
    rx: 40.878,
    ry: 51.167,
    transform: "translate(223.93 66.75)",
    fill: "#f2f2f2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M506.153,323.365h.112l2.021,115.9h-4.268Z",
    transform: "translate(-241.232 -215.737)",
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M732.763,633.745h0a1.011,1.011,0,0,1-.424,1.365l-5.863,3.087-.942-1.789,5.863-3.087A1.011,1.011,0,0,1,732.763,633.745Z",
    transform: "translate(-460.869 -449.39)",
    fill: "#ccc"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 40.878,
    cy: 51.167,
    rx: 40.878,
    ry: 51.167,
    transform: "translate(106.407 66.75)",
    fill: "#f2f2f2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M505.632,565.724h0a1.011,1.011,0,0,0-1.365-.423l-4.093,2.155-1.4-80.374h-.112l-2.133,115.9h4.268l-.58-33.258,5-2.63a1.011,1.011,0,0,0,.423-1.365Z",
    transform: "translate(-351.262 -379.453)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M565.342,280.653c28.607,0,51.858,53.9,51.858,89.709S594.01,435.2,565.4,435.2s-51.8-29.027-51.8-64.834S536.735,280.653,565.342,280.653Z",
    transform: "translate(-359.437 -280.653)",
    fill: "#6c63ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M619.577,526.356a1.28,1.28,0,0,0-1.73-.537l-5.186,2.73-1.776-101.843h-.142l-2.7,146.853h5.407l-.735-42.142,6.329-3.332A1.28,1.28,0,0,0,619.577,526.356Z",
    transform: "translate(-404.634 -350.557)",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoScenarioImage);
export default __webpack_public_path__ + "static/media/NoScenarioImage.975b9106d5e84aed7f02eeac575c3736.svg";
export { ForwardRef as ReactComponent };